var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.appState.isOnline && !_vm.appState.isNetworkError)?_c('refresher',{attrs:{"appstate":_vm.appState}}):_vm._e(),_c('header-main'),_vm._t("default"),_c('panel-bottom')],2)}
var staticRenderFns = []

export { render, staticRenderFns }